module.exports = __webpack_public_path__ + "img/before5.aca763bc.jpg";